import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { types as passengerTypes } from 'types/passengers';
import { removeLeadingZeros } from 'utils/functions';

import { PassengerButton } from './CoachAndSeatButton.styles';

const CoachAndSeatButton = ({ seatDetails, ...props }) => {
  let children;
  if (seatDetails) {
    if (seatDetails.passenger.type !== passengerTypes.INFANT) {
      children = `${seatDetails.coach} / ${removeLeadingZeros(seatDetails.number)}`;
    } else {
      children = <FormattedMessage id="paxForm.seat.infant" />;
    }
  } else {
    children = '-- --';
  }

  return <PassengerButton {...props}>{children}</PassengerButton>;
};

CoachAndSeatButton.propTypes = {
  seatDetails: PropTypes.shape({
    coach: PropTypes.string,
    number: PropTypes.string,
    passenger: PropTypes.shape({
      type: PropTypes.string
    })
  })
};

export default CoachAndSeatButton;
